module.exports = __webpack_public_path__ + "media/images/achievement_category/submission_count-328d847fa8df97657c163d402e4de939.png";